<apx-chart [series]="series" [chart]="chart" [tooltip]="tooltip" [plotOptions]="plotOptions"></apx-chart>
